import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "@data-phone/react-resource-server-auth";
import {
  setAgents,
  setAgentsLoading,
  setAgentsError,
} from "../slices/agents.slice";
import {
  setIVRMenus,
  setIVRMenusLoading,
  setIVRMenusError,
} from "../slices/ivr_menus.slice";
import {
  setQueues,
  setQueuesLoading,
  setQueuesError,
} from "../slices/queues.slice";

export const fetchDirectoryData = createAsyncThunk(
  "directory/fetchAll",
  async (_, { dispatch }) => {
    dispatch(setAgentsLoading());
    dispatch(setIVRMenusLoading());
    dispatch(setQueuesLoading());

    try {
      const res = await api.get(`${process.env.REACT_APP_LIVE_CALL_URL}/api/apps`);
      const result = res.result;

      dispatch(setAgents(result.extension || []));
      dispatch(setIVRMenus(result.ivr_menu || []));
      dispatch(setQueues(result.queue || []));

      return result;
    } catch (error: any) {
      const errMsg = error.message || "Failed to fetch directory data";
      dispatch(setAgentsError(errMsg));
      dispatch(setIVRMenusError(errMsg));
      dispatch(setQueuesError(errMsg));
      throw error;
    }
  }
);
